import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseModel } from '../models/response.model';
import { appEnv } from '../../app.config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransactionHeaderService {

  constructor(
    private http: HttpClient
  ) { }

  getById (id: number = 0): Observable<ResponseModel> {
    return this.http.get<ResponseModel>(`${appEnv.api}roster/id/${id}`);
  }

  getAvailableTransactions (): Observable<any> {
    return this.http.get<any>(`${appEnv.api}get-available-transaction`);
  }

  getAll (filter: any): Observable<ResponseModel> {
    const filters = new URLSearchParams(filter);
    return this.http.get<ResponseModel>(`${appEnv.api}roster/list?${filters}`);
  }
}
